import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogTrigger, DialogClose, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Edit } from 'lucide-react';
import { Note } from 'api-client';

interface EditeNoteDialogProps {
    isDialogOpen: number;
    setIsDialogOpen: (open: number) => void;
    note: Note | null;
    editNote: (id: string, note: Note) => void;
}

export const EditeNoteDialog = ({ isDialogOpen, setIsDialogOpen, note, editNote }: EditeNoteDialogProps) => {
    const [content, setContent] = useState('');
    
    useEffect(() => {
        if (!note) return;
        setContent(note.content);
    }, [note, isDialogOpen])

    const handleOpenChange = (open: boolean) => {
        setIsDialogOpen(open ? (note?.id || 0) : 0);
    };

    return (
        <Dialog open={isDialogOpen !== 0} onOpenChange={handleOpenChange} key={note?.id}>
            {/* <DialogTrigger asChild>
                <button onClick={() => console.log(note)} className="p-1.5 rounded-lg text-gray-400 hover:text-white hover:bg-gray-800/50 transition-colors">
                    <Edit className="h-4 w-4" />
                </button>
            </DialogTrigger> */}
            <DialogContent className="bg-[#1A1F2E] border border-gray-800 rounded-lg p-6">
                <DialogTitle>Edit Note {note?.id}</DialogTitle>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        const newContent = (e.currentTarget.elements[0] as HTMLTextAreaElement).value;
                        if (note && newContent !== note.content) {
                            editNote(note.id?.toString(), { ...note, content: newContent });
                        }
                        setIsDialogOpen(0);
                    }}
                    className="space-y-4"
                >
                    <textarea
                        value={content}
                        className="w-full h-32 px-4 py-3 bg-gray-800/30 border border-gray-800 rounded-lg text-gray-300 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 resize-none"
                        autoFocus
                        onChange={(e) => setContent(e.target.value)}
                    />
                    <div className="flex justify-end mt-4 space-x-2">
                        <DialogClose asChild>
                            <Button variant="outline" className="mr-2">
                                Cancel
                            </Button>
                        </DialogClose>
                        <Button type="submit">
                            Save
                        </Button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
};
